module.exports = __webpack_public_path__ + "img/sys-name.36488d70.png";